<template>
  <div>
    <!-- <ConsultAdd
      :is-add-new-consult-sidebar-active.sync="isAddNewConsultSidebarActive"
      @createConsult="createConsult"
    /> -->
    <b-sidebar
      id="add-new-appointment-sidebar"
      :visible="isAddNewAppointmentSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      z-index="1300"
      @hidden="resetForm"
      @change="val => $emit('update:is-add-new-appointment-sidebar-active', val)">
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">Add New Appointment</h5>

          <i class="fas fa-times ml-1 cursor-pointer" size="16" @click="hide"></i>
        </div>

        <!-- BODY -->
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm">
            <validation-provider
              #default="validationContext"
              name="Patient"
              rules="required">
              <b-form-group :label="$t('Patient')" label-for="patient">
                <b-form-input
                  disabled
                  :value="`${userAppointment.name} ${userAppointment.lastname}`" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- City: input + lista automática debajo (sin clic en select) -->
            <validation-provider
              #default="validationContext"
              name="City"
              rules="required">
              <b-form-group
                :label="$t('Form.City')"
                label-for="city-appointment"
                class="city-autocomplete-wrap">
                <b-form-input
                  id="city-appointment"
                  v-model="cityName"
                  :state="getValidationState(validationContext)"
                  placeholder="Enter city name"
                  @input="searchCitiesFromInput"
                  @focus="cityName && searchCitiesFromInput()" />
                <div v-if="cityOptions.length" class="city-options-list">
                  <div
                    v-for="opt in cityOptions"
                    :key="opt.value"
                    class="city-option-item"
                    @mousedown.prevent="selectCityOption(opt)">
                    {{ opt.text }}
                  </div>
                </div>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Zip Code -->
            <validation-provider
              #default="validationContext"
              name="Zip Code"
              rules="required">
              <b-form-group label="Zip Code" label-for="zip-code-appointment">
                <b-form-input
                  id="zip-code-appointment"
                  v-model="stateData.zip_codes_id"
                  :state="getValidationState(validationContext)"
                  type="number"
                  placeholder="Enter zip code" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Type Visit"
              rules="required">
              <b-form-group :label="$t('Types of visits')" label-for="type visit">
                <!-- <v-select
                  id="type visit"
                  v-model="stateData.typeVisit"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeVisit"
                  @search="searchTypeVisit"
                  :reduce="(option) => option.id"
                  :clearable="false"
                  label="name"
                /> -->
                <treeselect
                  id="type_consult"
                  v-model="stateData.typeVisit"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeVisit"
                  :normalizer="normalizer" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Visit reason"
              rules="required">
              <b-form-group label-for="visit_reason">
                <label for="visit_reason">{{ $t('Visit Reason') }}</label>
                <treeselect
                  id="visit_reason"
                  v-model="stateData.reason_visit"
                  :options="visitReasonOptions"
                  :normalizer="normalizer"
                  :searchable="true"
                  :clearable="true"
                  :multiple="false"
                  placeholder="Select a visit reason"
                  :max-height="200"
                  :options-limit="50"
                  :class="{
                    'custom-treeselect': true,
                    'is-invalid': validationContext.touched && !validationContext.valid
                  }" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Other Reason Input (conditional) -->
            <validation-provider
              v-if="showOtherReasonInput"
              #default="validationContext"
              name="Other Reason"
              rules="required">
              <b-form-group label-for="reason_visit_other">
                <label for="reason_visit_other">{{ $t('Please specify') }}</label>
                <b-form-textarea
                  id="reason_visit_other"
                  v-model="stateData.reason_visit_other"
                  :state="getValidationState(validationContext)"
                  placeholder="Please specify the reason for your visit"
                  rows="3" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- <validation-provider
              #default="validationContext"
              name="Visit Reason"
              rules="required"
            >
              <b-form-group label-for="type_consult">
                <div class="d-flex justify-content-between">
                  <label for="type_consult">{{ $t("Visit Reason") }}</label>
                  <b-button
                    size="sm"
                    variant="success"
                    class="btn-icon button-custom"
                    @click="isAddNewConsultSidebarActive = true"
                  >
                    <i class="wizard-icon fas fa-plus-circle"></i>
                  </b-button>
                </div> -->
            <!-- <v-select
                  id="type_consult"
                  v-model="stateData.typeConsultation"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeConsult"
                  @search="searchTypeConsult"
                  :clearable="false"
                  label="name"
                >
                </v-select> -->
            <!-- <treeselect
                  id="type_consult"
                  v-model="stateData.typeConsultation"
                  :state="getValidationState(validationContext)"
                  :options="optionsTypeConsult"
                  :normalizer="normalizer"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider> -->

            <validation-provider
              v-show="checkCodeQr"
              #default="validationContext"
              name="Qr"
              :rules="checkCodeQr ? 'required' : null">
              <b-form-group label="Qr" label-for="Qr">
                <b-form-input
                  id="Qr"
                  v-model="stateData.codeQr"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Code qr" />
              </b-form-group>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>

            <checkCupon :cupon.sync="stateData.cupon" @cancelCupon="cancelCupon" />

            <membershipPerUser
              v-if="stateData.typeVisit == 8"
              :id_user="userAppointment.id"
              :membership.sync="stateData.membership_id" />

            <validation-provider
              v-if="stateData.typeVisit == 2 || stateData.typeVisit == 8 || stateData.typeVisit == 13 || stateData.typeVisit == 14"
              #default="validationContext"
              name="reference"
              rules="required">
              <b-form-group label-for="reference">
                <label for="reference">{{ $t('Reference') }}</label>
                <treeselect
                  id="reference"
                  v-model="stateData.user_references_id"
                  :state="getValidationState(validationContext)"
                  :options="optionsReferenceList"
                  :normalizer="normalizer" />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- <b-button
              @click="scanPromotion"
              :variant="checkCodeQr ? 'primary' : 'outline-primary'"
            >
              Scan QR
            </b-button> -->

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button variant="primary" class="mr-1" type="submit" :disabled="loading">
                <span v-if="!loading">{{ $t('Add') }}</span>
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
              <b-button type="button" variant="outline-danger" @click="hide">
                {{ $t('Cancel') }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend,
  BButton,
} from 'bootstrap-vue'
import formValidation from '@/core/utils/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastNotification from '@/components/ToastNotification'
import checkCupon from '@/components/checkCupon'
import { notificationCheck } from '@/mixins/NotificationSetup'

import SpinnerLoading from '@/components/SpinnerLoading'

import flatPickr from 'vue-flatpickr-component'

import { required } from '@validations'
import { computed, onMounted, ref, watch } from '@vue/composition-api'

import axiosA from '@/core/services/api/appointment'
import axiosAC from '@/core/services/api/appointment/actions'
import axiosTV from '@/core/services/api/admin/consults/visits'
import axiosC from '@/core/services/api/admin/consults/consults'
import axiosCities from '@/core/services/api/admin/cities'
import axiosP from '@/core/services/api/patient'
import membershipPerUser from '../../../../components/membershipPerUser.vue'

/* import ConsultAdd from "@/views/admin/type-consult/consult/ConsultAdd"; */

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // BInputGroup,
    // BInputGroupAppend,
    SpinnerLoading,
    // flatPickr,
    ToastNotification,
    checkCupon,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    membershipPerUser,
  },
  model: {
    prop: 'isAddNewAppointmentSidebarActive',
    event: 'update:is-add-new-appointment-sidebar-active',
  },
  props: {
    isAddNewAppointmentSidebarActive: {
      type: Boolean,
      required: true,
    },
    userAppointment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visitReasonOptions: [
        { id: 'Other', name: 'Other' },
        { id: 'Abdominal Pain', name: 'Abdominal Pain' },
        { id: 'Allergies', name: 'Allergies' },
        { id: 'Anxiety', name: 'Anxiety' },
        { id: 'Back Pain', name: 'Back Pain' },
        { id: 'Breast Pain', name: 'Breast Pain' },
        { id: 'Chest Pain', name: 'Chest Pain' },
        { id: 'Cold Symptoms', name: 'Cold Symptoms' },
        { id: 'Consultation', name: 'Consultation' },
        { id: 'Cough', name: 'Cough' },
        { id: 'COVID', name: 'COVID' },
        { id: 'Dermatitis', name: 'Dermatitis' },
        { id: 'Diabetes', name: 'Diabetes' },
        { id: 'Diarrhea', name: 'Diarrhea' },
        { id: 'DIU Removal', name: 'DIU Removal' },
        { id: 'Dizziness', name: 'Dizziness' },
        { id: 'DM Control', name: 'DM Control' },
        { id: 'Earache', name: 'Earache' },
        { id: 'Exams', name: 'Exams' },
        { id: 'Fever', name: 'Fever' },
        { id: 'Flu', name: 'Flu' },
        { id: 'Follow Up', name: 'Follow Up' },
        { id: 'General Check', name: 'General Check' },
        { id: 'General Exam', name: 'General Exam' },
        { id: 'Headache', name: 'Headache' },
        { id: 'Health Checkup', name: 'Health Checkup' },
        { id: 'HTN Control', name: 'HTN Control' },
        { id: 'Ingrown Toe Nail', name: 'Ingrown Toe Nail' },
        { id: 'Injection', name: 'Injection' },
        { id: 'IV Therapy', name: 'IV Therapy' },
        { id: 'Knee Pain', name: 'Knee Pain' },
        { id: 'Lab Result', name: 'Lab Result' },
        { id: 'Lower Back Pain', name: 'Lower Back Pain' },
        { id: 'Menstrual Disorder', name: 'Menstrual Disorder' },
        { id: 'Pending Injection', name: 'Pending Injection' },
        { id: 'Physical School', name: 'Physical School' },
        { id: 'Pregnancy Test', name: 'Pregnancy Test' },
        { id: 'Rash', name: 'Rash' },
        { id: 'Refill', name: 'Refill' },
        { id: 'Respiratory Disorder', name: 'Respiratory Disorder' },
        { id: 'Result', name: 'Result' },
        { id: 'Semaglutide', name: 'Semaglutide' },
        { id: 'Shoulder pain', name: 'Shoulder pain' },
        { id: 'Skin Lesion', name: 'Skin Lesion' },
        { id: 'Sore Throat', name: 'Sore Throat' },
        { id: 'Stomachache', name: 'Stomachache' },
        { id: 'USG', name: 'USG' },
        { id: 'Vitamin pack', name: 'Vitamin pack' },
        { id: 'X Ray', name: 'X Ray' },
      ],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  setup(props, { emit }) {
    const isAddNewConsultSidebarActive = ref(false)
    const stateDataTem = {
      reason_visit: null,
      reason_visit_other: '',
      userType: '',
      patient: null,
      typeVisit: null,
      typeConsultation: null,
      scanQr: null,
      cupon: '',
      membership_id: null,
      user_references_id: null,
      cities_id: null,
      zip_codes_id: null,
    }
    const stateData = ref(JSON.parse(JSON.stringify(stateDataTem)))
    const cityName = ref('')
    const cityOptions = ref([])
    const setTimeoutCitySearch = ref(null)

    const resetstateData = () => {
      stateData.value = JSON.parse(JSON.stringify(stateDataTem))
      cityName.value = ''
      cityOptions.value = []
    }

    const checkCodeQr = ref(false)
    const toast = ref(null)

    watch(
      () => props.userAppointment,
      (patient) => {
        if (!patient || !patient.id) {
          cityName.value = ''
          cityOptions.value = []
          stateData.value.cities_id = null
          stateData.value.zip_codes_id = null
          return
        }
        stateData.value.zip_codes_id = patient.zip_codes_id ?? null
        if (patient.cities && patient.cities.name) {
          cityName.value = patient.cities.name
          cityOptions.value = [{ text: patient.cities.name, value: patient.cities.id }]
          stateData.value.cities_id = patient.cities_id
        } else {
          cityName.value = ''
          cityOptions.value = []
          axiosP.patientDetail(patient.id).then((response) => {
            const registro = response?.registro ?? response
            if (registro?.cities) {
              cityName.value = registro.cities.name || ''
              cityOptions.value = [{ text: registro.cities.name, value: registro.cities.id }]
              stateData.value.cities_id = registro.cities_id ?? registro.cities.id
            } else if (registro?.cities_id) {
              stateData.value.cities_id = registro.cities_id
            }
            if (registro?.zip_codes_id != null) {
              stateData.value.zip_codes_id = registro.zip_codes_id
            }
          }).catch(() => {})
        }
      },
      { immediate: true }
    )

    const searchCitiesFromInput = () => {
      if (!cityName.value || !cityName.value.length) {
        cityOptions.value = []
        return
      }
      clearTimeout(setTimeoutCitySearch.value)
      setTimeoutCitySearch.value = setTimeout(() => {
        axiosCities
          .citiesFilterFilters({ name: cityName.value })
          .then((response) => {
            const list = Array.isArray(response) ? response : (response && response.data) || []
            cityOptions.value = (list || []).map(city => ({
              text: city.name,
              value: city.id,
            }))
          })
          .catch(() => {
            cityOptions.value = []
          })
      }, 350)
    }

    const onCitySelect = () => {
      const selected = cityOptions.value.find(opt => opt.value === stateData.value.cities_id)
      if (selected) cityName.value = selected.text
    }

    const selectCityOption = (opt) => {
      stateData.value.cities_id = opt.value
      cityName.value = opt.text
      cityOptions.value = []
    }

    const searchCities = ({ action, searchQuery, callback }) => {
      if (action === 'ASYNC_SEARCH') {
        clearTimeout(clearTimeoutBuscador.value)
        clearTimeoutBuscador.value = setTimeout(() => {
          axiosCities
            .citiesFilterFilters({ name: searchQuery })
            .then((response) => {
              const list = Array.isArray(response) ? response : (response && response.data) || []
              callback(null, list || [])
            })
            .catch(() => callback(null, []))
        }, 350)
      }
    }

    watch(
      () => stateData.value.codeQr,
      (newValue, oldValue) => {
        if (newValue !== null || newValue.length > 0) {
          const data = {
            codeQr: stateData.value.codeQr,
          }
          axiosAC.appointmentAssignCuppon(data).then(res => {
            const { type, message } = notificationCheck(res)
            toast.value[type](message)
          })
        }
      }
    )

    watch(
      () => stateData.value.reason_visit,
      () => {
        clearOtherReason()
      }
    )

    const scanPromotion = () => {
      if (checkCodeQr.value) {
        stateData.value.codeQr = null
      }
      checkCodeQr.value = !checkCodeQr.value
    }

    const createConsult = () => {
      loadTypeConsult()
      isAddNewConsultSidebarActive.value = false
    }

    const showOtherReasonInput = computed(() => {
      return stateData.value.reason_visit === 'Other'
    })

    const optionsTypeVisit = ref([])
    const optionsTypeConsult = ref([])
    const clearTimeoutBuscador = ref('')
    const optionsReferenceList = ref([])

    onMounted(() => {
      loadTypeVisit()
      loadTypeConsult()
      loadReferencesList()
    })

    /**
     * Filtra los tipos de visita para excluir los relacionados con insurance
     * Excluye tipos que contengan "insurance" en el nombre
     */
    const filterNonInsuranceVisitTypes = visitTypes => {
      if (!Array.isArray(visitTypes)) return []
      return visitTypes.filter(visit => {
        const name = (visit.name || '').toString().toLowerCase()
        // Excluir tipos que contengan "insurance"
        return !name.includes('insurance')
      })
    }

    const loadTypeVisit = () => {
      axiosTV.visitList(20).then(({ data }) => {
        const findItem = data.findIndex(item => item.id === 3)
        if (findItem !== -1) {
          data.splice(findItem, 1)
        }
        // Excluir tipos de visita relacionados con insurance
        optionsTypeVisit.value = filterNonInsuranceVisitTypes(data)
      })
    }
    const loadTypeConsult = () => {
      axiosC.consultList(10).then(({ data }) => {
        optionsTypeConsult.value = data
      })
    }
    const searchTypeVisit = (name, loading) => {
      if (name.length) {
        const datos = {
          name,
        }
        loading(true)
        clearTimeout(clearTimeoutBuscador.value)
        clearTimeoutBuscador.value = setTimeout(() => {
          axiosTV.visitFilter(20, datos).then(({ registro: { data } }) => {
            loading(false)
            const findItem = data.findIndex(item => item.id === 3)
            if (findItem !== -1) {
              data.splice(findItem, 1)
            }
            // Excluir tipos de visita relacionados con insurance
            optionsTypeVisit.value = filterNonInsuranceVisitTypes(data)
          })
        }, 400)
      }
    }
    const searchTypeConsult = (name, loading) => {
      if (name.length) {
        const datos = {
          name,
        }
        loading(true)
        clearTimeout(clearTimeoutBuscador.value)
        clearTimeoutBuscador.value = setTimeout(() => {
          axiosC.consultFilter(10, datos).then(({ data }) => {
            loading(false)
            optionsTypeConsult.value = data
          })
        }, 400)
      }
    }
    const loading = ref(false)
    const onSubmit = async () => {
      loading.value = true

      // Determine the final reason_visit value
      let finalReasonVisit = stateData.value.reason_visit
      if (stateData.value.reason_visit === 'Other' && stateData.value.reason_visit_other) {
        finalReasonVisit = stateData.value.reason_visit_other
      }
      
      // Create a copy of stateData without reason_visit_other
      const { reason_visit_other, ...stateDataWithoutOther } = stateData.value

      const datos = {
        membership_id:
          stateData.value.typeVisit == 8 ? stateData.value.membership_id : null,
        cupon: stateData.value.cupon,
        user_type: 'established',
        patients_id: props.userAppointment.id,
        type_visits_id: stateData.value.typeVisit,
        reason_visit: finalReasonVisit,
        codeQr: stateData.value.codeQr,
        queryType: 'NC',
        user_references_id: stateData.value.user_references_id || null,
        type_membership: 'NC',
        cities_id: stateData.value.cities_id,
        zip_codes_id: stateData.value.zip_codes_id,
      }
      await axiosA
        .appointmentCreate(datos)
        .then(res => {
          const { type, message } = notificationCheck(res)
          emit('createAppointment', {
            type,
            message,
          })
          resetstateData()
        })
        .catch(() => {
          loading.value = false
          const { type, message } = notificationCheck(res)
          emit('createAppointment', {
            type,
            message,
          })
        })
    }

    const loadReferencesList = () => {
      axiosP.referencePagination(10, 1).then(({ data }) => {
        optionsReferenceList.value = data.data
      })
    }

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetstateData)
    const config = {
      altFormat: 'F j, Y',
      dateFormat: 'Y-m-d',
      static: true,
    }
    const cancelCupon = () => {
      stateData.value.cupon = ''
    }

    const clearOtherReason = () => {
      if (stateData.value.reason_visit !== 'Other') {
        stateData.value.reason_visit_other = ''
      }
    }
    return {
      loading,
      stateData,
      optionsTypeVisit,
      optionsTypeConsult,
      searchCities,
      cityName,
      cityOptions,
      searchCitiesFromInput,
      onCitySelect,
      selectCityOption,
      toast,
      checkCodeQr,
      scanPromotion,
      isAddNewConsultSidebarActive,
      createConsult,
      searchTypeConsult,
      searchTypeVisit,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      config,
      cancelCupon,
      optionsReferenceList,
      showOtherReasonInput,
    }
  },
}
</script>

<style lang="scss" scoped>
.button-custom {
  padding: 5px !important;
}

.city-autocomplete-wrap {
  position: relative;
}

.city-options-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 2px;
}

.city-option-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s ease;
}

.city-option-item:hover {
  background-color: #f8f9fa;
}

.city-option-item:last-child {
  border-bottom: none;
}
</style>
